export enum VehicleCheckLocalStorage {
  KEY = 'inspectionFilterKey',
  TYPE = 'inspectionFilterType',
  STATUS = 'inspectionFilterStatus',
  START_DATE = 'inspectionFilterStartDate',
  END_DATE = 'inspectionFilterEndDate',
  GROUP_ID = 'inspectionFilterGroupId',
  COMPANY_ID = 'inspectionFilterCompanyId',
  BRANCH_ID = 'inspectionFilterBranchId',
}
